module.exports = __webpack_public_path__ + "lp/img/color_palette-blue.f3bfdfcf.svg";